import { Link } from "react-router-dom";

const CATEGORIES = [
  {
    name: "电影",
    icon: "ri-movie-2-line",
    desc: "院线大片 · 高分佳作",
    to: "/category?type=电影",
    image:
      "https://readdy.ai/api/search-image?query=Dark%20cinematic%20collage%20of%20a%20vintage%20film%20projector%20beam%20cutting%20through%20dusty%20theater%20air%2C%20deep%20navy%20and%20amber%20tones%2C%20moody%20dramatic%20lighting%2C%20minimal%20elegant%20composition&width=600&height=400&seq=cat-movie&orientation=landscape",
  },
  {
    name: "电视剧",
    icon: "ri-live-line",
    desc: "追剧更新 · 全集热播",
    to: "/category?type=电视剧",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20living%20room%20with%20a%20large%20television%20glowing%20soft%20warm%20light%20in%20the%20evening%2C%20cozy%20deep%20blue%20and%20amber%20tones%2C%20cinematic%20depth%20of%20field%2C%20minimal%20elegant%20interior&width=600&height=400&seq=cat-tv&orientation=landscape",
  },
  {
    name: "综艺",
    icon: "ri-mic-line",
    desc: "爆笑真人秀 · 音乐竞演",
    to: "/category?type=综艺",
    image:
      "https://readdy.ai/api/search-image?query=Vibrant%20stage%20with%20colorful%20spotlights%20and%20confetti%20falling%20over%20an%20empty%20mic%20stand%2C%20warm%20orange%20and%20teal%20glow%2C%20festive%20energetic%20cinematic%20atmosphere&width=600&height=400&seq=cat-variety&orientation=landscape",
  },
];

export default function CategoryQuickLinks({ counts }: { counts: Record<string, number> }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
      {CATEGORIES.map((cat) => (
        <Link
          key={cat.name}
          to={cat.to}
          className="group relative h-40 md:h-48 rounded-lg overflow-hidden cursor-pointer"
        >
          <img
            src={cat.image}
            alt={cat.name}
            title={`${cat.name}频道 水母影视`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950/95 via-primary-950/50 to-primary-950/10"></div>
          <div className="absolute inset-0 p-5 flex flex-col justify-end">
            <span className="w-9 h-9 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center mb-3">
              <i className={`${cat.icon} text-lg`}></i>
            </span>
            <h3 className="font-heading text-xl font-bold text-background-50">{cat.name}频道</h3>
            <p className="mt-1 text-xs text-background-200 flex items-center gap-2 flex-wrap">
              <span>{cat.desc}</span>
              <span className="w-1 h-1 rounded-full bg-background-200/60"></span>
              <span>共 {counts[cat.name] ?? 0} 部</span>
            </p>
          </div>
        </Link>
      ))}
    </div>
  );
}